<template>
	<div class="parserDetail">
		<el-button type="primary" plain class="backClass" @click="backClick()">返回</el-button>
		<div class="tableBox">
			<el-table :data="rowList" style="width: 100%">
				<el-table-column prop="name" label="抄读名称" min-width="1%">
				</el-table-column>
				<el-table-column prop="remark" label="备注" min-width="1%">
				</el-table-column>
				<el-table-column prop="" label="" min-width="3%">
				</el-table-column>
			</el-table>
		</div>
		<div class="headerBox">
			抄读项列表
			<!--TODO-->
			<!--<el-button type="primary" plain class="addButtonClass3" @click="batchDeleteClick()">批量删除</el-button>-->
			<el-button type="primary" plain class="addButtonClass2" @click="batchCopyClick()">批量复制</el-button>
			<el-button type="primary" plain class="addButtonClass" @click="addClick()" v-if="lock_status==0">新建抄读项</el-button>
		</div>
		<div class="tableBox">
			<el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange" ref="multipleTable" v-loading="loading">
				<el-table-column label="选取" type="selection" width="55" style="height:20px">
				</el-table-column>
				<el-table-column label="序 号" width="70">
					<template slot-scope="scope"><span style="padding-left: 4px;">{{(pageIndex-1)*pageSize+scope.$index+1}}</span></template>
				</el-table-column>
				<el-table-column prop="name" label="抄读子集" min-width="1%">
				</el-table-column>
				<el-table-column prop="code" label="数据标识" min-width="1%">
				</el-table-column>
				<el-table-column prop="total" label="包含数据项" min-width="1%">
				</el-table-column>
				<el-table-column prop="" label="是否事件" min-width="1%">
					<template slot-scope="scope">{{scope.row.isevent|iseventFilter}}</template>
				</el-table-column>
				<el-table-column prop="" label="操作" min-width="1%">
					<template slot-scope="scope">
						<a class="editClass" @click.prevent="detailClick(scope.row.id,scope.row)">查看</a>
						<a class="editClass" @click.prevent="deleteClick(scope.row.id,scope.row.code)" v-if="lock_status==0">删除</a>
						<a class="editClass" @click.prevent="exportClick(scope.row.id)">导出</a>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="pagination">
			<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[20, 50, 100, 200]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" v-if="total>20" :current-page.sync="pageIndex">
			</el-pagination>
		</div>
		<!--弹窗-->
		<div class='popContainer' v-if="show" :style="{'padding': paddingV+'%' }">
			<div class="headerTop">
				<span style="margin-left: 20px;">新增抄读项</span>
				<div class="buttomBox">
					<el-button @click="save()" class="confrim" type="primary">确定</el-button>
					<el-button @click="cancleClick('cancle')" class="cancle">取消</el-button>
				</div>
			</div>
			<div class="headerTop">
				<span style="margin-left: 20px;">数据标识</span>
				<input type="text" class="inputClass" v-model="codeValue" @change="codeValueChange()" />
				<span style="margin-left: 20px;">抄读子集</span>
				<input type="text" class="inputClass" v-model="childValue" />
				<div class="rightBox">
					<span style="margin-left: 20px;" class="numText">数据项数量</span>
					<input type="text" class="inputClass2" v-model="codeNum" :disabled="firstDisabled" />
					<el-button type="primary" plain class="clickButtonClass" @click="createClick()" :disabled="firstDisabled">生成</el-button>
				</div>
			</div>
			<div class="content">
				<!--父表格-->
				<!--<el-table :data="dataList" style="width: 100%" ref="tableRef" @expand-change="expandSelect" type='index' :row-key='getRowKeys' :expand-row-keys="expands" :row-class-name="getRowClass">-->
				<el-table :data="dataList" style="width: 100%" ref="tableRef" :row-class-name="getRowClass">
					<!--序号-->
					<el-table-column prop="" label="序号" min-width="1%">
						<template slot-scope="scope">
							{{scope.row.index}}
						</template>
					</el-table-column>
					<el-table-column prop="" label="" min-width="2%" type="expand">
						<template slot-scope="scope">
							<div class="childTable" @click="expandChange(scope.$index)" @mouseover="mouseOver(scope.$index)">
								<!--子①表格------------------------------------------->
								<el-table :data="scope.row.item" style="width: 100%" v-show="scope.row.type==1" ref="tableRef3" @expand-change="expandSelect" type='index' :row-key='getRowKeys' :expand-row-keys="expands" :row-class-name="getRowClass3">
									<el-table-column prop="" label="" min-width="4%"></el-table-column>
									<el-table-column prop="" label="" min-width="3%" type="expand">
										<template slot-scope="scope">
											<div class="childTable" @click="expandChangeT(scope.$index)">
												<!--子②表格=====================================-->
												<el-table :data="scope.row.itemSecond" style="width: 100%">
													<el-table-column prop="" label="" min-width="8%"></el-table-column>
													<el-table-column prop="" label="值" min-width="2%">
														<template slot-scope="scope">
															<el-input v-model="scope.row.val" type="number"></el-input>
														</template>
													</el-table-column>
													<el-table-column prop="" label="对应含义" min-width="4%">
														<template slot-scope="scope">
															<el-input v-model="scope.row.name"></el-input>
														</template>
													</el-table-column>

													<el-table-column prop="" label="" min-width="2%" v-if="scope.row.isevent_C">
														<template slot-scope="scope">
															<div class="checkBoxClass">
																<el-checkbox v-model="scope.row.isevent_T">事件</el-checkbox>
															</div>
														</template>
													</el-table-column>
													<el-table-column prop="" label="" min-width="15%" v-else>
													</el-table-column>
													<el-table-column prop="" label="详情OAD" min-width="13%" v-if="scope.row.isevent_C">
														<template slot-scope="scope">
															<el-input v-model="scope.row.oad" @input="scope.row.oad = scope.row.oad.replace(/[\u4e00-\u9fa5d]/g, '');"></el-input>
															<!--<el-input v-model="scope.row.oad" @input="oadChange(scope.row.oad)"></el-input>-->
														</template>
													</el-table-column>
												</el-table>
												<!--<el-button type="primary" icon="el-icon-plus" circle class="addButtonClassF" @click.stop="addCreate3(scope.$index)"></el-button>-->
											</div>
										</template>
									</el-table-column>
									<!--<el-table-column prop="" label="" min-width="4%"></el-table-column>-->
									<!--TODO-->
									<!--子①第一级-->
									<!--<el-table-column prop="" label="一级分类" min-width="3%">
										<template slot-scope="scope">
											<div class="selectClass">
												<a-select show-search v-model="scope.row.title_code_C" show-search option-filter-prop="children" style="width: 100%" :filter-option="filterOption" dropdownClassName="select-drop-down-platform">
													<a-select-option v-for="(item,index) in titleData" :key="index" :label="item.title" :value="item.id">
														{{item.title}}
													</a-select-option>
												</a-select>
											</div>
										</template>
									</el-table-column>
									<el-table-column prop="" label="二级分类" min-width="3%">
										<template slot-scope="scope">
											<div class="selectClass">
												<a-select show-search v-model="scope.row.title_code_C" show-search option-filter-prop="children" style="width: 100%" :filter-option="filterOption" dropdownClassName="select-drop-down-platform">
													<a-select-option v-for="(item,index) in titleData" :key="index" :label="item.title" :value="item.id">
														{{item.title}}
													</a-select-option>
												</a-select>
											</div>
										</template>
									</el-table-column>-->
									<!--<el-table-column prop="" label="抄读项" min-width="4%">
										<template slot-scope="scope">
											<select v-model="scope.row.title_code_C" placeholder="请选择" style="width:100%">
												<option v-for="item in titleData" :key="item.id" :label="item.title" :value="item.id">
												</option>
											</select>
										</template>
									</el-table-column>-->
									<!--子①抄读项-->
									<el-table-column prop="" label="抄读项" min-width="4%">
										<template slot-scope="scope">
											<el-select v-model="scope.row.title_code_C" class="select-unitName select-option-father" popper-class="select_report_and_type" :popper-append-to-body="false" ref="elSelectTable">
												<el-option :value="baseTableList">
													<el-tree class="unit-tree" node-key="label" :props="defaultProps" :default-expanded-keys="unitTreeExpandedId" ref="tableDom" highlight-current :expand-on-click-node='false' @node-click="clickUnitTreeNodeChild" lazy :load="load" @current-change="rowClick(scope.$index)">
													</el-tree>
												</el-option>
											</el-select>
										</template>
									</el-table-column>
									<!--子①起始字节-->
									<el-table-column prop="" label="起始字节" min-width="3%">
										<template slot-scope="scope">
											<el-input v-model="scope.row.start_idx_C" @change="start_idxChange(scope.row.isenum,scope.$index,scope.row)"></el-input>
										</template>
									</el-table-column>
									<!--子①结束字节-->
									<el-table-column prop="" label="结束字节" min-width="3%">
										<template slot-scope="scope">
											<el-input v-model="scope.row.end_idx_C" @change="start_idxChange(scope.row.isenum,scope.$index,scope.row)"></el-input>
										</template>
									</el-table-column>
									<el-table-column prop="" label="" min-width="2%">
										<!--子②表格====-->
										<!--<span class="numText" style="font-size: 12px;">子子项数量</span>-->
									</el-table-column>
									<el-table-column prop="" label="是否有值含义" min-width="5%">
										<template slot-scope="scope">
											<!--子②表格===-->
											<el-radio v-model="scope.row.isenum" label="1" @change="radioChange(scope.row.isenum,scope.$index,scope.row)">是</el-radio>
											<el-radio v-model="scope.row.isenum" label="0" @change="radioChange(scope.row.isenum,scope.$index,scope.row)">否</el-radio>
											<!--<div>
												<input type="text" class="inputClass3" :disabled="scope.row.thirdDisabled" v-model="scope.row.codeNum3" />
												<el-button type="primary" plain class="clickButtonClass2" @click="createClick3(scope.$index,scope.row.codeNum3,scope.row)" :disabled="scope.row.thirdDisabled">生成</el-button>
											</div>-->
										</template>
									</el-table-column>
									<!--子①单位-->
									<el-table-column prop="" label="单位" min-width="2%">
										<template slot-scope="scope">
											<el-input v-model="scope.row.unit_name_C" v-if="scope.row.isenum=='0'"></el-input>
										</template>
									</el-table-column>
									<!--子①精度-->
									<el-table-column prop="" label="数据精度" min-width="3%">
										<template slot-scope="scope">
											<el-input v-model="scope.row.precision_str_C" type="number" max="9" min="0" v-if="scope.row.isenum=='0'"></el-input>
										</template>
									</el-table-column>
									<!--子①变比-->
									<el-table-column prop="" label="" min-width="2%">
										<template slot-scope="scope">
											<div class="checkBoxClass">
												<el-checkbox v-model="scope.row.isevent_C" @change="eventChange(scope.row.isevent_C,scope.$index,scope.row)">事件</el-checkbox>
											</div>
										</template>
									</el-table-column>
									<el-table-column prop="" label="变比" min-width="4%">
										<template slot-scope="scope">
											<div class="checkBoxClass" v-if="scope.row.isenum=='0'">
												<el-checkbox v-model="scope.row.isa_C">电流</el-checkbox>
											</div>
											<div class="checkBoxClass" v-if="scope.row.isenum=='0'">
												<el-checkbox v-model="scope.row.isv_C">电压</el-checkbox>
											</div>
										</template>
									</el-table-column>
									<el-table-column prop="" label="操作" min-width="2%">
										<template slot-scope="scope">
											<a class="editClass" @click="deleteClickS(scope.$index)">删除</a>
										</template>
									</el-table-column>
								</el-table>
								<el-button type="primary" icon="el-icon-plus" circle class="addButtonClassF" @click="addCreate2(scope.$index)" v-if="scope.row.type==1"></el-button>
							</div>
						</template>
					</el-table-column>
					<!--父表格内容------------------------------------------------------------------------------>
					<el-table-column prop="" label="配置类型" min-width="3%">
						<template slot-scope="scope">
							<select v-model="scope.row.type" placeholder="请选择" style="width:100%">
								<option v-for="item in configurationTypeList" :key="item.id" :label="item.name" :value="item.id">
								</option>
							</select>
						</template>
					</el-table-column>
					<!--TODO-->
					<!--<el-table-column prop="" label="一级分类" min-width="3%">
						<template slot-scope="scope">
							<div class="selectClass">
								<a-select show-search v-model="scope.row.title_code" show-search option-filter-prop="children" style="width: 100%" :filter-option="filterOption" v-show="scope.row.type==0" @change="specilChange(scope.row.title_code,scope.$index)" dropdownClassName="select-drop-down-platform">
									<a-select-option v-for="(item,index) in titleData" :key="index" :label="item.title" :value="item.id">
										{{item.title}}
									</a-select-option>
								</a-select>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="" label="二级分类" min-width="3%">
						<template slot-scope="scope">
							<div class="selectClass">
								<a-select show-search v-model="scope.row.title_code" show-search option-filter-prop="children" style="width: 100%" :filter-option="filterOption" v-show="scope.row.type==0" @change="specilChange(scope.row.title_code,scope.$index)" dropdownClassName="select-drop-down-platform">
									<a-select-option v-for="(item,index) in titleData" :key="index" :label="item.title" :value="item.id">
										{{item.title}}
									</a-select-option>
								</a-select>
							</div>
						</template>
					</el-table-column>-->
					<!--<el-table-column prop="" label="抄读项" min-width="4%">
						<template slot-scope="scope">
							<select v-model="scope.row.title_code" placeholder="请选择" style="width:100%" v-show="scope.row.type==0" @change="specilChange(scope.row.title_code,scope.$index)">
								<option v-for="item in titleData" :key="item.id" :label="item.title" :value="item.id">
								</option>
							</select>
						</template>
					</el-table-column>-->
					<el-table-column prop="" label="抄读项" min-width="4%">
						<template slot-scope="scope">
							<el-select v-model="scope.row.title_code" class="select-unitName select-option-father" popper-class="select_report_and_type" :popper-append-to-body="false" ref="elSelectTable" v-show="scope.row.type==0">
								<el-option :value="baseTableList">
									<el-tree class="unit-tree" node-key="label" :props="defaultProps" :default-expanded-keys="unitTreeExpandedId" ref="tableDom" highlight-current :expand-on-click-node='false' @node-click="clickUnitTreeNode" lazy :load="load" @current-change="rowClick(scope.$index)">
									</el-tree>
								</el-option>
							</el-select>
						</template>
					</el-table-column>
					<el-table-column prop="" label="起始字节" min-width="3%">
						<template slot-scope="scope">
							<el-input v-model="scope.row.start_idx"></el-input>
						</template>
					</el-table-column>
					<el-table-column prop="" label="结束字节" min-width="3%">
						<template slot-scope="scope">
							<el-input v-model="scope.row.end_idx"></el-input>
						</template>
					</el-table-column>
					<el-table-column prop="" label="" min-width="2%">
						<template slot-scope="scope">
							<div class="checkBoxClass" v-if="scope.row.type==0">
								<el-checkbox v-model="scope.row.sort_type" v-show="scope.row.type==0">倒序</el-checkbox>
							</div>
							<!--子①表格-->
							<span class="numText" v-if="scope.row.type==1">子项数量</span>
						</template>
					</el-table-column>
					<el-table-column prop="" label="数据类型" min-width="5%">
						<template slot-scope="scope">
							<select v-model="scope.row.data_type" placeholder="请选择" style="width:100%" v-show="scope.row.type==0">
								<option v-for="item in dataTypeList" :key="item" :label="item" :value="item">
								</option>
							</select>
							<!--子①表格-->
							<div v-if="scope.row.type==1">
								<input type="text" class="inputClass3" v-model="scope.row.codeNum2" :disabled="scope.row.secondDisabled" />
								<el-button type="primary" plain class="clickButtonClass2" @click="createClick2(scope.$index,scope.row.codeNum2,scope.row)" :disabled="scope.row.secondDisabled">生成</el-button>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="" label="单位" min-width="2%">
						<template slot-scope="scope">
							<el-input v-model="scope.row.unit_name" v-show="scope.row.type==0"></el-input>
						</template>
					</el-table-column>
					<el-table-column prop="" label="数据精度" min-width="3%">
						<template slot-scope="scope">
							<el-input v-model="scope.row.precision_str" v-show="scope.row.type==0" type="number" max="9" min="0"></el-input>
						</template>
					</el-table-column>
					<el-table-column prop="" label="" min-width="2%">
						<template slot-scope="scope">
							<div class="checkBoxClass" v-if="scope.row.type==0">
								<el-checkbox v-model="scope.row.isevent" v-show="scope.row.type==0">事件</el-checkbox>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="" label="变比" min-width="4%">
						<template slot-scope="scope">
							<div class="checkBoxClass" v-if="scope.row.type==0">
								<el-checkbox v-model="scope.row.isa" v-show="scope.row.type==0">电流</el-checkbox>
							</div>
							<div class="checkBoxClass" v-if="scope.row.type==0">
								<el-checkbox v-model="scope.row.isv" v-show="scope.row.type==0">电压</el-checkbox>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="" label="操作" min-width="2%">
						<template slot-scope="scope">
							<a class="editClass" @click.prevent="deleteClickQ(scope.$index)">删除</a>
						</template>
					</el-table-column>
				</el-table>
				<el-button type="primary" icon="el-icon-plus" circle class="addButtonClassF" @click="addCreate()"></el-button>
			</div>

		</div>
		<!--批量复制弹窗-->
		<div class="batchCopyClass">
			<el-dialog title="批量复制" :visible.sync="dialogFormVisible1" :width="dialogWidth" :close-on-click-modal="false">
				<div style="margin-bottom: 18px;">
					<span style="display:inline-block;width:21%;text-align: center">复制数据标识</span>
					<span>新的数据标识</span>
				</div>
				<el-form>
					<div v-for="item in multipleSelection">
						<el-form-item :label="item.name" label-width="20%">
							<el-input type="text" v-model="item.nameNew" autocomplete="off" :placeholder="item.code" @input="nameNewChange()"></el-input>
						</el-form-item>
					</div>
				</el-form>
				<div style="margin-left: 16px;">
					<div style="margin-bottom: 18px;">目标抄读方式</div>
					<el-autocomplete class="inline-input" v-model="nameValue" :fetch-suggestions="querySearch" placeholder="单行输入" :trigger-on-focus="false" @select="handleSelect" style="width:100%"></el-autocomplete>
					<!--<el-input type="text" v-model="nameValue" autocomplete="off" placeholder="单行输入"></el-input>-->
				</div>
				<div slot="footer" class="dialog-footer">
					<el-button @click="saveCopy()" class="confrim" type="primary">确认复制</el-button>
					<el-button @click="dialogFormVisible1=false" class="cancle">取消</el-button>
				</div>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	import { mapGetters, mapActions } from 'Vuex';
	import headers from '../../../static/js/headers.js'
	import dataList from '../../../static/js/dataList.js'
	import md5 from '../../../static/js/md5.js'
	import qs from 'qs'
	import axios from 'axios'
	export default {
		mounted() {
			this.firstPageIndex = this.$route.query.fI
			if(this.$route.query.sI) {
				this.pageIndex = this.$route.query.sI
			}
			if(typeof(this.pageIndex) != 'number') {
				this.pageIndex = Number(this.pageIndex)
			}
			this.dataTypeList = dataList.dataTypeList;
			this.parser_id = this.$route.query.id
			this.getParserList(); //parse列表
			this.getById();
			this.getList(); //列表
			this.titleList(); //数据项列表
			//this.getTitle_categoryList(); //字典分类列表
		},
		filters: {
			iseventFilter: function(val) {
				if(val == "0") {
					return "no";
				}
				if(val == "1") {
					return "yes";
				}
			}
		},
		computed: {
			...mapGetters(['http'])
		},
		data() {
			return {
				loading: false, //加载状态
				pageSize: 20, //每页条数
				firstPageIndex: '', //第一个页面的当前页
				pageIndex: 1, //当前页
				total: 0, //总条数
				tableData: [],
				/*表单*/
				nameValue: '', //名称
				remark: '', //备注
				parser_id: '', //id
				rowList: [], //id列表
				/*弹窗*/
				show: false, //遮罩层
				paddingV: '0.5',
				dataList: [], //弹窗列表
				codeValue: '', //数据标识
				childValue: '', //抄读子集
				codeNum: '', //数据项数量
				codeNum2: '', //数据项数量2
				codeNum3: '', //数据项数量2
				configurationTypeList: [{
						id: 0,
						name: '常规'
					},
					{
						id: 1,
						name: '位解析'
					},
				], //配置类型
				dataTypeList: [], //数据类型
				titleData: [], //数据项
				firstDisabled: false, //第一次生成
				parentIndex: '', //第一层id
				childrenId: '', //第一层id
				parser_itemId: '', //parser_item的id
				childrenIdT: '', //第二层id
				parentIndexT: '', //第二层id
				expands: [],
				multipleSelection: [],
				dialogFormVisible1: false,
				dialogWidth: '40%', //dialog的宽度
				restaurants: [], //parser列表
				destId: '', //目标抄读设置ID
				lock_status: '', //锁定状态
				//select
				baseTableList: [],
				unitTreeExpandedId: [],
				baseTableName: '',
				defaultProps: {
					children: 'children',
					label: 'title',
					isLeaf: (data, node) => {
						if(node.level === 3) {
							return true
						}
					}
				},
				row_index: '', //第一级/第二级父级索引
				parent_index: '' //第一级索引
			}
		},

		methods: {
			filterOption(input, option) {
				return(
					option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
				);
			},
			//parser列表
			getParserList() {
				var params = {
					pageSize: -1,
					pageIndex: 1,
				}
				//console.log(params)
				let config = headers.headers('getListByLimit')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/parser/getListByLimit', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data.length > 0) {
						this.restaurants = res.data
						this.restaurants.forEach(item => {
							item.value = item.name
						})
					} else {
						this.restaurants = []
					}
				}).catch(err => {
					console.log(err)
				})
			},
			/*搜索parser列表*/
			querySearch(queryString, cb) {
				var restaurants = this.restaurants;
				var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
				// 调用 callback 返回建议列表的数据
				cb(results);
			},
			createFilter(queryString) {
				return(restaurant) => {
					return(restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
				};
			},
			handleSelect(item) {
				this.destId = item.id
			},
			//复选框触发
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			//批量删除
			batchDeleteClick() {
				if(this.multipleSelection.length > 0) {
					let config = headers.headers('save')
					var pass_token = config.pass_token
					var timestamp = config.timestamp
					this.$confirm('确认要删除吗?', '注意', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
					}).then(() => {
						for(var i = 0; i < this.multipleSelection.length; i++) {
							axios.post(this.http + '/zkep2/parser_item/save', qs.stringify({
								id: this.multipleSelection[i].id,
								status: 0,
							}), {
								headers: {
									'pass-token': pass_token,
									'time': timestamp
								}
							}).then(res => {
								//console.log(res)
								this.getList();
							}).catch(err => {
								console.log(err)
								this.$message({
									type: 'error',
									message: '删除失败!'
								});
								return
							})
						}
						this.$message({
							type: 'success',
							message: '删除成功!'
						});
					}).catch(() => {
						this.$message({
							type: 'info',
							message: '已取消删除'
						});
					});
				} else {
					this.$message({
						type: 'info',
						message: '请至少选择一条批量删除的数据!'
					});
				}
			},
			//批量复制
			batchCopyClick() {
				this.nameValue = ''
				this.destId = ''
				this.multipleSelection.forEach(item => {
					delete item.nameNew
				})
				if(this.multipleSelection.length > 0) {
					this.dialogFormVisible1 = true
				} else {
					this.$message({
						type: 'info',
						message: '请至少选择一条批量复制的数据!'
					});
				}
			},
			//数据标识的改变
			nameNewChange() {
				var codeArr = []
				this.tableData.forEach(item => {
					codeArr.push(item.code)
				})
				//				this.multipleSelection.forEach(item => {
				//					codeArr.forEach(item_s => {
				//						if(item.nameNew == item_s) {
				//							item.nameNew = ''
				//							this.$message({
				//								type: 'info',
				//								message: '数据标识已存在，请重新输入新的数据标识!'
				//							});
				//						}
				//					})
				//				})
			},
			//确认复制
			saveCopy() {
				var j = 0;
				var arr = []
				var open = false;
				this.multipleSelection.forEach(item => {
					arr.push({
						code: item.nameNew,
						id: item.id
					})
					if(item.nameNew) {
						j++;
						if(j = this.multipleSelection.length) {
							open = true
						}
					} else {
						open = false
					}
				})
				var manager_id = window.sessionStorage.getItem('id')
				var params = {
					destId: this.destId,
					manager_id: manager_id,
				}
				//console.log(params)
				let config = headers.headers('copyItems')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				/*后台参数需要body和query中同时传*/
				if(this.destId && open) {
					axios.post(this.http + '/zkep2/parser_item/copyItems',
						arr, {
							params: params
						}, {
							headers: {
								"Content-type": "application/json",
								'pass-token': pass_token,
								'time': timestamp
							}
						}).then(res => {
						//console.log(res)
						if(res.data.res == 1) {
							this.dialogFormVisible1 = false
							this.toggleSelection()
							this.multipleSelection.forEach(item => {
								delete item.nameNew
							})
							this.getList()
							this.nameValue = ''
							this.destId = ''
							this.$message({
								type: 'success',
								message: '复制成功!'
							});
						} else {
							this.$message({
								type: 'error',
								message: res.data.msg + '！'
							});
						}
					}).catch(err => {
						console.log(err)
					})
				} else {
					//					this.multipleSelection.forEach(item => {
					//						delete item.nameNew
					//					})
					this.$message('请输入必填项！')
				}
			},
			//取消所有勾选
			toggleSelection() {
				this.$refs.multipleTable.clearSelection();
			},
			getRowKeys(row, val) {
				return row.sign
			},
			expandSelect(row, expandedRows) {
				var that = this
				if(expandedRows.length) {
					that.expands = []
					if(row) {
						that.expands.push(row.sign)
					}
				} else {
					that.expands = []
				}
			},
			//每页多少
			handleSizeChange(val) {
				this.pageSize = val;
				this.getList();
			},
			//更改页数
			handleCurrentChange(val) {
				this.pageIndex = val;
				this.getList();
			},
			//数据项列表
			titleList() {
				var params = {
					pageSize: -1,
					pageIndex: this.pageIndex,
				}
				//console.log(params)
				let config = headers.headers('getListByLimit')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/title/getListByLimit', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data.length > 0) {
						this.titleData = res.data
					} else {
						this.titleData = []
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//抄读parser列表
			getById() {
				var params = {}
				let config = headers.headers(this.parser_id)
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/parser/' + this.parser_id, {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data) {
						this.rowList = []
						this.lock_status = res.data.lock_status
						this.rowList.push(res.data)
					} else {
						this.rowList = []
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//总条数
			getTotal() {
				var params = {
					pageSize: this.pageSize,
					pageIndex: this.pageIndex,
					parser_id: this.parser_id,
				}
				let config = headers.headers('getListByLimitCount')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/parser_item/getListByLimitCount', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data) {
						this.total = res.data
					} else {
						this.total = 0
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//获取列表
			getList() {
				this.loading = true;
				var params = {
					pageSize: this.pageSize,
					pageIndex: this.pageIndex,
					parser_id: this.parser_id,
				}
				//console.log(params)
				let config = headers.headers('getListByLimit')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/parser_item/getListByLimit', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					this.loading = false
					this.getTotal();
					console.log(res)
					if(res.data.length > 0) {
						this.tableData = res.data
						this.tableData.forEach(item => {
							//item.checked = false
						})
					} else {
						this.tableData = []
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//新建抄读项
			addClick() {
				this.show = true
				this.firstDisabled = false
				this.cancleClick();
			},
			//删除
			deleteClick(id, code) {
				let config = headers.headers('save')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				var params = {
					id: id,
					code: code + '_' + id,
					status: 0
				}
				//console.log(params)
				this.$confirm('确认要删除吗?', '注意', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(() => {
					axios.post(this.http + '/zkep2/parser_item/save', qs.stringify(params), {
						headers: {
							'pass-token': pass_token,
							'time': timestamp
						}
					}).then(res => {
						//console.log(res)
						if(res.data.id) {
							this.getList();
							this.$message({
								type: 'success',
								message: '删除成功!'
							});
						} else {
							this.$message({
								type: 'error',
								message: '删除失败!'
							});
						}
					}).catch(err => {
						console.log(err)
					})

				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			//清空
			emptyList() {
				this.nameValue = ''
				this.remark = ''
				this.parser_id = ''
			},
			//导出
			exportClick(id) {
				let config = headers.headers('exportItem')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				var params = {
					path: '/mnt/xvdb/html/zkepA/storage/excel/',
					id: id
				}
				//console.log(params)
				axios.get(this.http + '/zkep2/parser_item/exportItem', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					this.openFullScreen()
					//console.log(res)
					if(res.data.res == '1') {
						setTimeout(() => {
							this.loadingAdd.close()
						}, 3000);
						var index = res.data.file.lastIndexOf("//");
						var fileName = res.data.file.substring(index + 2, res.data.file.length)

						//window.location.href = 'http://www.380v.com' + '/storage/excel/' + fileName
						/*防止下载txt文件直接打开而不是是下载*/
						/*注意：本地运行，还是会直接打开，部署到服务器就好啦！*/
						let fileUrl = 'http://www.380v.top' + '/storage/excel/' + fileName;
						let fileNameArray = fileUrl.split('/');
						let fileName = fileNameArray[fileNameArray.length - 1];
						let element = document.createElement('a');
						element.style.display = 'none';
						element.setAttribute('href', fileUrl);
						element.setAttribute('download', fileName);
						document.body.appendChild(element);
						element.click();
						document.body.removeChild(element);
					} else {
						res.msg = '导出失败'
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//查看//TODO
			detailClick(id, list) {
				//				this.$router.push({
				//					path: '/parser/parserChildrenDetail',
				//					name: 'ParserChildrenDetail',
				//					query: {
				//						id: id,
				//						list: JSON.stringify(list), //解决页面跳转时携带对象参数，在刷新页面时对象不展示的问题：（先把对象转成字符串，再JSON.parse转成对象）
				//					}
				//				})
				this.$router.push({
					path: '/parser/parserChildrenDetail',
					name: 'ParserChildrenDetail',
					query: {
						id: id,
						ls: this.lock_status,
						pid: this.parser_id,
						fI: this.firstPageIndex,
						sI: this.pageIndex,
					}
				})
			},
			//第一层每行
			shellFun() {
				this.dataList.push({
					type: 0, //配置类型
					title_code: '', //抄读项
					start_idx: '', //起始字节
					end_idx: '', //结束字节
					sort_type: false, //倒叙复选框
					data_type: '', //数据类型
					unit_name: '', //单位
					precision_str: '', //数据精度
					isevent: false, //事件复选框
					isa: false, //电流复选框
					isv: false, //电压复选框
					item: [], //子级
					sign: this.$uuid.v1()
				})
			},
			//第一层生成
			createClick() {
				this.firstDisabled = true
				for(var i = 1; i <= this.codeNum; i++) {
					this.shellFun()
					this.dataList.forEach((item, index) => {
						item.index = index + 1
					})
				}
			},
			//第一层新增+1
			addCreate() {
				var open = false;
				this.dataList.forEach((item, index) => {
					if(item.type == 0) {
						if(item.title_code || item.title_code == '0') {
							open = true;
						} else {
							open = false;
							this.$message('请输入抄读项！')
						}
					} else {
						open = true;
					}
				})
				if(open == true) {
					this.shellFun();
					this.dataList.forEach((item, index) => {
						item.index = index + 1
					})
					this.codeNum = this.dataList.length
				}
			},
			//第一层删除
			deleteClickQ(index) {
				this.dataList.forEach((item, i) => {
					if(i == index) {
						this.dataList.splice(index, 1);
					}
				})
				this.codeNum = this.dataList.length
			},
			//第二层生成
			createClick2(index, num, row) {
				this.dataList.forEach((item, i) => {
					if(item.type == 1) {
						if(i == index) {
							for(var i = 0; i < num; i++) {
								item.item.push({
									title_code_C: '', //子抄读项
									start_idx_C: '', //子起始字节
									end_idx_C: '', //子结束字节
									unit_name_C: '', //子单位
									precision_str_C: '', //子数据精度
									isevent_C: false, //子事件复选框
									isa_C: false, //子电流复选框
									isv_C: false, //子电压复选框
									isenum: '0',
									sign: this.$uuid.v1()
								})
							}
							item.item.forEach((item_z, i_z) => {
								item.secondDisabled = true
							})
						}
					}
				})
				this.$refs.tableRef.toggleRowExpansion(row);
			},
			//第二层新增+1
			addCreate2(index) {
				this.dataList.forEach((item, i) => {
					if(item.type == 1) {
						if(i == index) {
							item.item.push({
								title_code_C: '', //子抄读项
								start_idx_C: '', //子起始字节
								end_idx_C: '', //子结束字节
								unit_name_C: '', //子单位
								precision_str_C: '', //子数据精度
								isevent_C: false, //子事件复选框
								isa_C: false, //子电流复选框
								isv_C: false, //子电压复选框
								isenum: '0',
								sign: this.$uuid.v1()

							})
						}
						item.item.forEach((item_z, i_z) => {
							item.codeNum2 = item.item.length
						})
					}
				})
			},
			//第二层删除
			deleteClickS(index) {
				this.childrenId = ''
				window.sessionStorage.setItem('childrenId', index)
			},
			//第二层表格的点击（删除）
			expandChange(parentIndex) {
				//console.log(parentIndex,'父父级')
				this.parentIndex = parentIndex
				this.childrenId = window.sessionStorage.getItem('childrenId')
				if(this.childrenId) {
					this.dataList.forEach((item, i) => {
						if(item.type == 1) {
							if(i == this.parentIndex) {
								item.item.forEach((item_z, i_z) => {
									if(i_z == this.childrenId) {
										item.item.splice(this.childrenId, 1);
										window.sessionStorage.setItem('childrenId', '') //处理删除行的点击触发删除
										item.codeNum2 = item.item.length
									}
								})
							}
						}
					})
				}
			},
			/*
			 * 第三层
			 * */
			//起始字节、结束字节改变&&值的含义为是
			start_idxChange(val, index, row) {
				if(val == 1) {
					this.dataList.forEach((item, index_z) => {
						if(index_z == this.parentIndex) {
							item.item.forEach((item_s, index_s) => {
								if(index == index_s) {
									item_s.itemSecond = []
								}
							})
						}
					})
					this.radioChange(val, index, row)
					this.$refs.tableRef3.toggleRowExpansion(row);
				}
			},
			//单选框改变
			radioChange(val, index, row) {
				if(row.end_idx_C >= 0 && row.start_idx_C >= 0) {
					var byteNum = row.end_idx_C - row.start_idx_C + 1 //字节
					var binary = '' //二进制数
					for(var i = 0; i < byteNum; i++) {
						binary = binary + '1'
					}
					/*二进制转十进制*/
					var decimalism; //十进制数
					decimalism = parseInt(binary, 2)
					if(val == 0) { //否 删除所有
						this.dataList.forEach((item, index_z) => {
							if(index_z == this.parentIndex) {
								item.item.forEach((item_s, index_s) => {
									if(index == index_s) {
										item_s.itemSecond = []
									}
								})
							}
						})
					} else if(val == 1) { //是 增加
						this.dataList.forEach((item, index_z) => {
							if(index_z == this.parentIndex) {
								item.item.forEach((item_s, index_s) => {
									if(index == index_s) {
										var arr = []
										for(var i = 0; i <= decimalism; i++) {
											arr.push({
												//title_code_C: '', //子子抄读项
												val: i,
												name: '',
												isevent_T: false,
												oad: '',
											})
											item_s.itemSecond = arr
										}
									}
								})
							}
						})
					}
					this.$refs.tableRef3.toggleRowExpansion(row);
				}
			},
			//事件改变
			eventChange(val, index, row) {
				//				if(row.end_idx_C >= 0 && row.start_idx_C >= 0) {
				//					var byteNum = row.end_idx_C - row.start_idx_C + 1 //字节
				//					var binary = '' //二进制数
				//					for(var i = 0; i < byteNum; i++) {
				//						binary = binary + '1'
				//					}
				//					/*二进制转十进制*/
				//					var decimalism; //十进制数
				//					decimalism = parseInt(binary, 2)
				//					if(val == false) { //否 删除所有
				//						//						this.dataList.forEach((item, index_z) => {
				//						//							if(index_z == this.parentIndex) {
				//						//								item.item.forEach((item_s, index_s) => {
				//						//									if(index == index_s) {
				//						//										console.log(item_s.itemSecond)
				//						//										item_s.itemSecond.forEach(item_t => {
				//						//											item_t.isevent_T = ''
				//						//											item_t.oad = ''
				//						//										})
				//						//									}
				//						//								})
				//						//							}
				//						//						})
				//					} else if(val == true) { //是 增加
				//						//						this.dataList.forEach((item, index_z) => {
				//						//							if(index_z == this.parentIndex) {
				//						//								item.item.forEach((item_s, index_s) => {
				//						//									if(index == index_s) {
				//						//										var arr = []
				//						//										for(var i = 0; i <= decimalism; i++) {
				//						//											arr.push({
				//						//												isevent_T: '',
				//						//												oad: '',
				//						//											})
				//						//											item_s.itemSecond = arr
				//						//										}
				//						//									}
				//						//								})
				//						//							}
				//						//						})
				//					}
				////					this.$refs.tableRef3.toggleRowExpansion(row);
				////					this.$refs.tableRef3.toggleRowExpansion(row);
				//				}
			},
			//第三层生成//(已弃用)
			createClick3(index, num, row) {
				this.dataList.forEach((item) => {
					item.item.forEach((item_s, index_s) => {
						if(index == index_s) {
							var arr = []
							for(var i = 0; i < num; i++) {
								arr.push({
									//title_code_C: '', //子子抄读项
									val: 0,
									name: '',
								})
								item_s.itemSecond = arr
								item_s.thirdDisabled = true
							}
						}
					})
				})
				this.$refs.tableRef3.toggleRowExpansion(row);
			},
			//第三层新增+1
			addCreate3(index) {
				this.dataList.forEach((item, i) => {
					item.item.forEach((item_s, index_s) => {
						if(index == index_s) {
							item_s.itemSecond.push({
								//								title_code_C: '', //子子抄读项
								val: 0,
								name: '',
							})
							if(item_s.itemSecond.length > 0) {
								item_s.itemSecond.forEach(item_y => {
									item_s.codeNum3 = item_s.itemSecond.length
								})
							}
						}
					})
				})
			},
			//第三层删除
			deleteClickT(index) {
				//console.log(index,'当前')
				this.childrenIdT = ''
				window.sessionStorage.setItem('childrenIdT', index)
			},
			//第三层表格的点击（删除）
			expandChangeT(parentIndex) {
				//console.log(parentIndex,'父级')
				this.parentIndexT = parentIndex
				this.childrenIdT = window.sessionStorage.getItem('childrenIdT')
				if(this.childrenIdT) {
					this.dataList.forEach((item, i) => {
						if(i == this.parentIndex) {
							item.item.forEach((item_z, i_z) => {
								if(i_z == this.parentIndexT) {
									item_z.itemSecond.forEach((item_s, index_s) => {
										if(index_s == this.childrenIdT) {
											window.sessionStorage.setItem('childrenIdT', '') //处理删除行的点击触发删除
											item_z.itemSecond.splice(this.childrenIdT, 1);
											item_z.codeNum3 = item_z.itemSecond.length
										}
									})
								}
							})
						}
					})
				}
			},
			//抄读项的改变
			specilChange(val, index) {
				this.dataList.forEach((item, index_s) => {
					if(index != index_s) {
						if(item.title_code === val) {
							this.$message({
								type: 'info',
								message: '抄读项重复，请重新选择抄读项!'
							});
						}
					}
				})
			},
			//新建数据标识的改变
			codeValueChange() {
				var params = {
					parser_id: this.parser_id,
					code: this.codeValue
				}
				let config = headers.headers('getByParserAndCode')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/parser_item/getByParserAndCode', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data.id) {
						this.codeValue = ''
						this.$message({
							type: 'info',
							message: '数据标识已存在，请重新输入数据标识!'
						});
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//确认保存
			save() {
				//console.log(this.dataList)
				/*parser_item的保存*/
				var timestamp = Date.parse(new Date());
				var manager_id = window.sessionStorage.getItem('id')
				var params = {
					parser_id: this.parser_id,
					name: this.childValue,
					code: this.codeValue,
					total: this.codeNum,
					manager_id: manager_id,
					create_time: timestamp,
					isevent: 0,
					status: 1,
				}
				//console.log(params)
				let config = headers.headers('save')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				if(this.codeValue && this.codeNum && this.childValue) {
					axios.post(this.http + '/zkep2/parser_item/save',
						qs.stringify(params), {
							headers: {
								'pass-token': pass_token,
								'time': timestamp
							}
						}).then(res => {
						//console.log(res)
						if(res.data.id) {
							this.parser_itemId = res.data.id
							this.saveZ();
							this.getList();
							this.show=false
						} else {
							this.$message('新增失败！')
						}
					}).catch(err => {
						console.log(err)
					})
				} else {
					this.$message('请输入必填项！')
				}

			},
			//常规和位解析保存
			async saveZ() {
				//数据的处理
				this.dataList.forEach(item => {
					if(!item.sort_type) {
						item.sort_type = 0
					} else {
						item.sort_type = 1
					}
					if(!item.isevent) {
						item.isevent = 0
					} else {
						item.isevent = 1
					}
					if(!item.isa) {
						item.isa = 0
					} else {
						item.isa = 1
					}
					if(!item.isv) {
						item.isv = 0
					} else {
						item.isv = 1
					}
					if(item.item.length > 0) {
						item.item.forEach((item_z, i_z) => {
							if(!item_z.isevent_C) {
								item_z.isevent_C = 0
							} else {
								item_z.isevent_C = 1
							}
							if(!item_z.isa_C) {
								item_z.isa_C = 0
							} else {
								item_z.isa_C = 1
							}
							if(!item_z.isv_C) {
								item_z.isv_C = 0
							} else {
								item_z.isv_C = 1
							}
						})
					}
				})
				//todo
				if(this.parser_itemId) {
					this.dataList.forEach(item => {
						if(item.type == '1') {
							item.title_code = ''
							item.sort_type = 0
							item.data_type = ''
							item.unit_name = ''
							item.precision_str = 1
							item.isevent = 0
							item.isa = 0
							item.isv = 0
						}
						item.item.forEach(item_s => {
							if(item_s.isenum == '1') {
								item_s.unit_name_C = ''
								item_s.precision_str_C = 1
								//item_s.isevent_C = 0
								item_s.isa_C = 0
								item_s.isv_C = 0
							}
						})
					})
					this.dataList.forEach((item, i) => {
						this.titleData.forEach(items => {
							if(item.title_code == items.title) {
								item.title_code = items.id
							}
							item.item.forEach(itemc => {
								if(itemc.title_code_C == items.title) {
									itemc.title_code_C = items.id
								}
							})
						})
					})
					//console.log(this.dataList)
					for(var i = 0; i < this.dataList.length; i++) {
						var timestamp = Date.parse(new Date());
						var manager_id = window.sessionStorage.getItem('id')
						let config = headers.headers('save')
						var pass_token = config.pass_token
						var timestamp = config.timestamp
						const res2 = await axios.post(this.http + '/zkep2/parser_detail/save',
							qs.stringify({
								parser_id: this.parser_id, //所属抄读
								parser_item_id: this.parser_itemId, //所属抄读项id
								type: this.dataList[i].type, //类型
								parent_id: 0,
								title_code: this.dataList[i].title_code, //名称标识
								start_idx: this.dataList[i].start_idx, //开始字节
								end_idx: this.dataList[i].end_idx, //结束字节
								sort_type: this.dataList[i].sort_type, //是否倒序
								data_type: this.dataList[i].data_type, //数据类型
								unit_name: this.dataList[i].unit_name, //单位
								precision_str: this.dataList[i].precision_str, //精度
								isevent: this.dataList[i].isevent, //是否事件
								isa: this.dataList[i].isa, //是否乘电流倍比
								isv: this.dataList[i].isv, //是否乘电压倍比
								isenum: 0,
								status: 1,
								manager_id: manager_id,
								create_time: timestamp,
							}), {
								headers: {
									'pass-token': pass_token,
									'time': timestamp
								}
							}).then(async res => { //同步执行接口
							if(this.dataList[i].type != 1) {
								this.show = false
							}
							//console.log(res)
							if(res.data.id) {
								if(res.data.type == 1) {
									//console.log(res.data.id)
									if(this.dataList[i].item && this.dataList[i].item.length > 0) {
										for(var j = 0; j < this.dataList[i].item.length; j++) {
											var isenum;
											if(this.dataList[i].item[j].isenum == '0') {
												isenum = 0
											} else if(this.dataList[i].item[j].isenum == '1') {
												isenum = 1
											}
											var timestamp = Date.parse(new Date());
											var manager_id = window.sessionStorage.getItem('id')
											let config = headers.headers('save')
											var pass_token = config.pass_token
											var timestamp = config.timestamp
											const res3 = await axios.post(this.http + '/zkep2/parser_detail/save',
												qs.stringify({
													parser_id: this.parser_id, //所属抄读
													parser_item_id: this.parser_itemId, //所属抄读项id
													type: 1, //类型
													parent_id: res.data.id,
													title_code: this.dataList[i].item[j].title_code_C, //名称标识
													start_idx: this.dataList[i].item[j].start_idx_C, //开始字节
													end_idx: this.dataList[i].item[j].end_idx_C, //结束字节
													sort_type: 0, //是否倒序
													data_type: '', //数据类型
													unit_name: this.dataList[i].item[j].unit_name_C, //单位
													precision_str: this.dataList[i].item[j].precision_str_C, //精度
													isevent: this.dataList[i].item[j].isevent_C, //是否事件
													isa: this.dataList[i].item[j].isa_C, //是否乘电流倍比
													isv: this.dataList[i].item[j].isv_C, //是否乘电压倍比
													isenum: isenum,
													status: 1,
													manager_id: manager_id,
													create_time: timestamp,
												}), {
													headers: {
														'pass-token': pass_token,
														'time': timestamp
													}
												}).then(res => {
												//console.log(res)
												if(res.data.id) {
													var timestamp = Date.parse(new Date());
													var manager_id = window.sessionStorage.getItem('id')
													let config = headers.headers('save')
													var pass_token = config.pass_token
													var timestamp = config.timestamp
													if(this.dataList[i].item[j].itemSecond && this.dataList[i].item[j].itemSecond.length > 0) {
														for(var k = 0; k < this.dataList[i].item[j].itemSecond.length; k++) {
															if(this.dataList[i].item[j].isevent_C == 0) {
																this.dataList[i].item[j].itemSecond[k].isevent_T = false
																this.dataList[i].item[j].itemSecond[k].oad = ''
															}
															var isevent_T;
															if(this.dataList[i].item[j].itemSecond[k].isevent_T == true) {
																isevent_T = 1
															} else {
																isevent_T = 0
															}
															var oad;
															oad = this.dataList[i].item[j].itemSecond[k].oad.replace(/，/ig, ',');
															axios.post(this.http + '/zkep2/parser_enum/save',
																qs.stringify({
																	parser_detail_id: res.data.id,
																	val: this.dataList[i].item[j].itemSecond[k].val,
																	name: this.dataList[i].item[j].itemSecond[k].name,
																	isevent: isevent_T,
																	oad: oad,
																	status: 1,
																	manager_id: manager_id,
																	create_time: timestamp,
																}), {
																	headers: {
																		'pass-token': pass_token,
																		'time': timestamp
																	}
																}).then(res => {
																//console.log(res)
																if(res.data.id) {
																	this.show = false
																	//this.cancleClick()
																} else {
																	this.$message('新增失败！')
																}
															}).catch(err => {
																console.log(err)
															})
															//this.cancleClick()
														}
													}

												} else {
													this.$message('新增失败！')
												}
											}).catch(err => {
												console.log(err)
											})
										}
									} else {
										this.show = false
										//this.cancleClick()
									}
								}
							} else {
								this.$message('新增失败！')
							}
						}).catch(err => {
							console.log(err)
						})
					}
				}
			},
			//取消
			cancleClick(val) {
				if(val) {
					this.show = false
				}
				this.dataList = []
				this.codeNum = ''
				this.codeValue = ''
				this.parser_itemId = ''
			},
			//控制按钮的展示
			getRowClass(row, rowIndex) {
				let data = row.row;
				let res = [];
				if(data.item && data.item.length > 0) {
					res.push('row-expand-has')
					return res;
				} else {
					res.push('row-expand-unhas')
					return res;
				}
			},
			//控制按钮的展示2
			getRowClass3(row, rowIndex) {
				let data = row.row;
				let res = [];
				if(data.itemSecond && data.itemSecond.length > 0) {
					res.push('row-expand-has')
					return res;
				} else {
					res.push('row-expand-unhas')
					return res;
				}
			},
			//返回//TODO
			backClick() {
				this.$router.push({
					path: '/parser/parser',
					name: 'Parser',
					query: {
						fI: this.firstPageIndex
					}

				})
			},
			oadChange(val) {
				console.log(val)
				let reg = /[\u4e00-\u9fa5d]/g;
				if(new RegExp(reg).test(val.value)) { //非数字
					this.$message({
						message: '存在非法字符！',
						type: 'info'
					})
				}
			},
			//加载的动画
			openFullScreen() {
				this.loadingAdd = this.$loading({
					lock: true,
					text: '',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0)'
				});
			},
			mouseOver(parent_index) {
				this.parent_index = parent_index
			},
			//第一层第三级的点击
			clickUnitTreeNode(data) {
				if(data.parent_id == undefined) {
					this.dataList.forEach((item, i) => {
						this.titleData.forEach(items => {
							if(this.row_index == i) {
								if(data.title == items.title) {
									item.title_code = items.title
									this.$refs.elSelectTable.blur() // 收起下拉列表
								}
							}
						})
					})
				}
			},
			//第二层第三级的点击
			clickUnitTreeNodeChild(data) {
				if(data.parent_id == undefined) {
					this.dataList.forEach((item, i) => {
						if(i == this.parent_index) {
							item.item.forEach((item_c, i_c) => {
								this.titleData.forEach(items => {
									if(this.row_index == i_c) {
										if(data.title == items.title) {
											item_c.title_code_C = items.title
											this.$refs.elSelectTable.blur() // 收起下拉列表
										}
									}
								})
							})
						}

					})
				}
			},
			rowClick(val) {
				this.row_index = val
			},
			//第一级列表
			async treeList(resolve) {
				var params = {
					pageSize: -1,
					pageIndex: this.pageIndex,
					parent_id: 0
				} //console.log(params)
				let config = headers.headers('getListByLimit')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				const res = await axios.get(this.http + '/zkep2/title_category/getListByLimit', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					return resolve(res.data);
				}).catch(err => {
					console.log(err)
				})
			},
			//第二级列表
			async loadchildnode(node, resolve) {
				var params = {
					pageSize: -1,
					pageIndex: this.pageIndex,
					parent_id: node.data.id
				} //console.log(params)
				let config = headers.headers('getListByLimit')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				const res2 = await axios.get(this.http + '/zkep2/title_category/getListByLimit', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					return resolve(res.data);
				}).catch(err => {
					console.log(err)
				})
			},
			//第三级列表
			async getLowerList(node, resolve) {
				var params = {
					pageSize: -1,
					pageIndex: this.pageIndex,
					title_category_id: node.data.id
				} //console.log(params)
				let config = headers.headers('getListByLimit')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				const res2 = await axios.get(this.http + '/zkep2/title_link/getListByLimit', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					return resolve(res.data);
				}).catch(err => {
					console.log(err)
				})
			},
			//加载
			load(node, resolve) {
				/*懒加载缓存刷新处理*/
				if(node.level === 0) {
					this.treeList(resolve);
				}
				if(node.level == 1) {
					this.loadchildnode(node, resolve);
				}
				if(node.level == 2) {
					this.getLowerList(node, resolve);
				}
			},
		}
	}
</script>

<style>
	.parserDetail {
		height: 100%;
		padding: 3.2% 12% 0 12%;
		position: relative;
	}
	
	.parserDetail .backClass {
		padding: 8px 22px;
		font-size: 13px;
		margin-bottom: 24px;
	}
	
	.parserDetail .el-table th {
		color: #000;
	}
	
	.parserDetail .el-table {
		font-size: 12px;
	}
	
	.parserDetail .el-table th,
	.parserDetail .el-table td,
	.parserDetail .el-table tr {
		background-color: #FFF;
		padding: 6px 0!important;
		text-align: left;
	}
	
	.parserDetail .el-table th {
		padding: 10px 0!important;
		font-weight: 400;
		text-align: left;
		color: #999;
	}
	
	.parserDetail .headerBox {
		position: relative;
		height: 30px;
		line-height: 30px;
		padding: 6px 30px;
		border: 1px solid #EEE;
		border-radius: 3px;
		background-color: #fff;
		font-size: 13px;
		margin-bottom: 10px;
		margin-top: 10px;
	}
	
	.parserDetail .addButtonClass2 {
		position: absolute;
		top: 2px;
		right: 112px;
		width: 90px;
		font-size: 13px;
		padding: 11px;
	}
	
	.parserDetail .addButtonClass3 {
		position: absolute;
		top: 2px;
		right: 214px;
		width: 90px;
		font-size: 13px;
		padding: 11px;
	}
	
	.parserDetail .addButtonClass {
		position: absolute;
		top: 2px;
		right: 10px;
		width: 90px;
		font-size: 13px;
		padding: 11px;
	}
	
	.parserDetail .tableBox {
		padding: 0 20px;
		border: 1px solid #EEE;
		border-radius: 3px;
		background-color: #fff;
	}
	
	.parserDetail .editClass {
		color: #439DFD;
		margin-right: 10px;
		cursor: pointer;
	}
	
	.parserDetail .el-dialog__title {
		color: #999;
	}
	
	.parserDetail .el-dialog__footer {
		text-align: center;
	}
	
	.parserDetail .pagination {
		text-align: center;
	}
	
	.parserDetail .pagination .el-input__inner {
		height: 30px;
		line-height: 30px;
	}
	/*遮罩层*/
	
	.parserDetail .popContainer {
		font-size: 13px;
		z-index: 2;
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background: rgba(0, 0, 0, 0.5);
		padding-top: 8%!important;
		padding-bottom: 8%!important;
		/*padding: 8% 20%;*/
		/*height: 100%;*/
		overflow: auto;
	}
	
	.parserDetail .headerTop {
		position: relative;
		width: 100%;
		height: 50px;
		line-height: 50px;
		margin-bottom: 1%;
		background-color: #fff!important;
	}
	
	.parserDetail .inputClass {
		text-indent: 10px;
		outline: none;
		padding: 6px 0;
		border: 1px solid #ccc;
		width: 20%;
	}
	
	.parserDetail .rightBox {
		position: absolute;
		top: 0;
		right: 16%;
	}
	
	.parserDetail .inputClass2 {
		text-indent: 10px;
		outline: none;
		padding: 6px 0;
		border: 1px solid #ccc;
	}
	
	.parserDetail .clickButtonClass {
		border-radius: 0;
		padding: 7px 16px;
		margin-left: -4px;
	}
	
	.parserDetail .buttomBox {
		position: absolute;
		top: 0;
		right: 10px;
	}
	
	.parserDetail .confrim,
	.parserDetail .cancle {
		padding: 10px 26px;
	}
	
	.parserDetail .content {
		width: 100%;
		background-color: #fff!important;
	}
	
	.parserDetail .content .el-input__inner {
		height: 30px;
		line-height: 30px;
		border-radius: 0;
		padding: 0px;
		text-align: center;
	}
	
	.parserDetail .content select {
		height: 30px;
		line-height: 30px;
		border: 1px solid #ccc;
		outline: none;
		border-radius: 5px;
		color: #999;
	}
	/*复选框*/
	
	.parserDetail .checkBoxClass {
		display: inline-block;
		width: 18px;
		margin-right: 40px;
		height: 18px;
		line-height: 10px;
		padding: 2px 1px;
		background-color: #0079DD;
		text-align: center;
		vertical-align: top;
	}
	
	.parserDetail .el-checkbox__inner {
		border: 1px solid #fff!important;
		background-color: #0079DD;
		border-radius: 0!important;
	}
	
	.parserDetail .el-checkbox__input.is-checked .el-checkbox__inner,
	.parserDetail .el-checkbox__input.is-indeterminate .el-checkbox__inner {
		background-color: #0079DD;
		border-color: #0079DD!important;
	}
	
	.parserDetail .el-checkbox__input.is-checked+.el-checkbox__label {
		color: #000;
		font-size: 12px;
	}
	
	.parserDetail .el-checkbox__label {
		vertical-align: top;
		font-size: 12px;
	}
	
	.parserDetail .inputClass3 {
		width: 100px;
		text-indent: 10px;
		outline: none;
		padding: 6px 0;
		border: 1px solid #ccc;
	}
	
	.parserDetail .clickButtonClass2 {
		vertical-align: top;
		border-radius: 0;
		padding: 7px 6px;
		margin-left: -4px;
	}
	
	.parserDetail .childTable .el-table th {
		/*display: none;*/
		border-top: none;
		padding-top: 0px!important;
		padding-bottom: 0px !important;
	}
	
	.parserDetail .el-table .cell {
		padding-right: 2px;
	}
	
	.parserDetail .addButtonClassF {
		margin: 6px 0 6px 95%;
	}
	/*控制折叠按钮的展示*/
	
	.parserDetail .row-expand-unhas .el-table__expand-column {
		pointer-events: none;
	}
	
	.parserDetail .row-expand-unhas .el-table__expand-column .el-icon {
		visibility: hidden;
	}
	
	.parserDetail .tableBox .el-checkbox__inner {
		border: 1px solid #ccc!important;
		background-color: #fff;
		border-radius: 0!important;
	}
	
	.parserDetail .batchCopyClass .el-dialog__title {
		color: #fff;
	}
	
	.parserDetail .batchCopyClass .el-dialog__header {
		padding-top: 0!important;
		padding-bottom: 0;
		;
	}
	
	.parserDetail .batchCopyClass .el-dialog__headerbtn .el-dialog__close {
		color: #fff;
	}
	/*加载图标*/
	
	.el-loading-spinner {
		font-size: 46px;
	}
	
	.el-loading-spinner i {
		color: #34495e!important;
		opacity: 0.7;
	}
	
	.parserDetail .el-button.is-circle {
		border-radius: 50%;
		padding: 6px;
	}
	
	.select-drop-down-platform {
		width: 200px!important;
	}
	
	select {
		font-size: 13px;
		padding: 0;
	}
	/*select-tree样式*/
	
	.parserDetail .el-scrollbar .el-scrollbar__view .el-select-dropdown__item {
		height: auto;
		max-height: 274px;
		padding: 0;
		overflow: hidden;
		overflow-y: auto;
	}
	
	.parserDetail .el-select .el-input__inner {
		border-radius: 4px!important;
		border: 1px solid #ccc;
		color: #999;
		text-align: left;
		text-indent: 6px;
	}
	
	.parserDetail .is-leaf::before {
		opacity: 0;
	}
	/*媒体查询*/
	
	@media screen and (max-width: 670px) {
		.parserDetail .numText {
			display: none;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/Parser/ParserDetail.vue